import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  OnDestroy,
  Renderer2,
  Signal,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FloatingTrackService } from '../../../services';
import { Portal, PortalModule } from '@angular/cdk/portal';
import { FloatingButtonComponent } from '../floating-button/floating-button.component';
@Component({
  selector: 'dw-ui-floating-track',
  standalone: true,
  imports: [CommonModule, PortalModule, FloatingButtonComponent],
  templateUrl: './floating-track.component.html',
  styleUrl: './floating-track.component.css',
})
export class FloatingTrackComponent implements AfterViewInit, OnDestroy {
  selectedPortals: Signal<Portal<any>[]> = this.floatingTrackService.portalContent;
  @HostBinding('style.--yPosition') yPosition = localStorage.getItem('yPosition') || '50dvh';
  @HostBinding('style.--floating-container-height') floatingcontainerheight = '0px';

  @ViewChild('dragdropButton') dragdropButton!: FloatingButtonComponent;
  @ViewChild('floatingContainer') floatingTrack!: ElementRef<HTMLDivElement>;

  isDragging = false;
  startY = 0;
  resizeObserver: ResizeObserver;

  constructor(
    private floatingTrackService: FloatingTrackService,
    private renderer: Renderer2,
  ) {}

  ngAfterViewInit() {
    this.floatingTrack.nativeElement.style.width = `${this.dragdropButton.buttonElement.nativeElement.clientWidth}px`;
    this.renderer.listen(document, 'mousemove', (event: MouseEvent) => this.onMouseMove(event));
    this.renderer.listen(document, 'mouseup', () => this.onDragEnd());
    this.resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        this.floatingcontainerheight = entry.target.clientHeight + 'px';
      });
    });
    this.resizeObserver.observe(this.floatingTrack.nativeElement);
  }

  ngOnDestroy(): void {
    this.resizeObserver.disconnect();
  }

  onMouseMove(event: MouseEvent): void {
    if (this.isDragging) {
      this.yPosition = `${event.clientY + 33}px`;
      this.startY = event.clientY;
    }
  }

  onDragEnd(): void {
    this.isDragging = false;
    localStorage.setItem('yPosition', this.yPosition);
  }
}
